var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigPaperPre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 20,
    height: 20,
    rx: 10,
    transform: "rotate(-180 20 20)",
    fill: "#F38D33"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.917 8.66634V11.333C12.917 12.8216 12.917 13.5659 12.4315 13.8572C11.946 14.1485 11.2893 13.7982 9.97581 13.0977L7.47582 11.7644C6.01993 10.9879 5.29199 10.5997 5.29199 9.99967C5.29199 9.39967 6.01993 9.01144 7.47582 8.23497L9.97582 6.90163C11.2893 6.20113 11.946 5.85088 12.4315 6.14218C12.917 6.43348 12.917 7.17777 12.917 8.66634Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigPaperPre);
export default __webpack_public_path__ + "static/media/jobconfig-paper-pre.1c2a5f62c703518ee8de3a4c0904c001.svg";
export { ForwardRef as ReactComponent };